import { createFileRoute } from '@tanstack/react-router'

import { OnboardingWizard } from '@/features/onboarding/components/onboarding-wizard'
import { useProfileQuery } from '@/lib/api/profile'

export const Route = createFileRoute('/_authed/profile/edit')({
  component: () => {
    const { data: profile, isLoading } = useProfileQuery()
    if (isLoading) return null
    if (!profile) return null
    const initialValues = {
      firstName: profile.firstName ?? '',
      lastName: profile.lastName ?? '',
      dob: profile.birthDate,
      tob: profile.birthTime ?? null,
      birthLocation: profile.birthPlace
        ? {
            label: profile.birthPlace.city,
            lat: profile.birthPlace.latitude,
            lng: profile.birthPlace.longitude,
            countryCode: profile.birthPlace.countryCode,
          }
        : null,
      timezone: profile.timezone,
      marketingConsent: profile.marketingConsent ?? false,
    }
    return <OnboardingWizard initialValues={initialValues} />
  },
})
